import axios from "axios";
import { adalConfig } from "../../common/endpoints";

export const unlinkUserProject = async (tenantId: string, objectId: string,projectId:string) => {
  try {
    const response = await axios.delete(
       adalConfig.endpoints.deletemultiappdata + `?tenantId=${tenantId}&objectId=${objectId}&projectId=${projectId}`
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error.response.data.message || "Something went wrong");
  }
};
